import { render, staticRenderFns } from "./imgChat.vue?vue&type=template&id=55aa5a7e&scoped=true"
import script from "./imgChat.vue?vue&type=script&lang=js"
export * from "./imgChat.vue?vue&type=script&lang=js"
import style0 from "./imgChat.vue?vue&type=style&index=0&id=55aa5a7e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55aa5a7e",
  null
  
)

export default component.exports